"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const SlideDrawer_1 = __importDefault(require("../SlideDrawer/SlideDrawer"));
const useWidgetCallback_1 = require("../../hooks/useWidgetCallback");
const store_1 = require("../../context/store");
const styled_1 = require("./styled");
const QrScanner_1 = __importDefault(require("../QrScanner/QrScanner"));
const addressValidator_1 = require("../../helpers/addressValidator");
const actions_1 = require("../../context/actions");
const QRIcon_1 = __importDefault(require("../Icons/QRIcon"));
const ArrowIcon_1 = __importDefault(require("../Icons/ArrowIcon"));
const NoWallet_1 = __importDefault(require("../NoWallet/NoWallet"));
const AddressInput = ({ open, setOpen, hasPassthrough }) => {
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const [tempAddress, setTempAddress] = (0, react_1.useState)("");
    const [validAddress, setValidAddress] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(false);
    const [qrOpen, setQrOpen] = (0, react_1.useState)(false);
    const { provider, fiatValue, selectedCrypto, selectedFiat, address } = (0, store_1.useTrackedState)();
    const dispatch = (0, store_1.useDispatch)();
    const callback = (0, useWidgetCallback_1.useWidgetCallback)();
    const handleClose = (0, react_1.useCallback)(() => {
        setOpen(false);
        setTempAddress("");
        dispatch({
            type: actions_1.CONTEXT_ACTIONS.SET_ADDRESS,
            payload: "",
        });
        setValidAddress(false);
        setError(false);
    }, [dispatch, setOpen]);
    (0, react_1.useEffect)(() => {
        if (address) {
            setTempAddress(address);
            const cleanedAddress = (0, addressValidator_1.cleanAddress)(address);
            const validatedAddress = (0, addressValidator_1.validateAddress)(cleanedAddress);
            if (validatedAddress) {
                setValidAddress(validatedAddress);
            }
            else {
                setError(true);
            }
        }
    }, [address, selectedCrypto.code]);
    const handleChange = (0, react_1.useCallback)((e) => {
        setTempAddress(e.target.value);
        if (!e.target.value) {
            dispatch({
                type: actions_1.CONTEXT_ACTIONS.SET_ADDRESS,
            });
            setError(false);
            setValidAddress(false);
            return;
        }
        const cleanedAddress = (0, addressValidator_1.cleanAddress)(e.target.value);
        const validatedAddress = (0, addressValidator_1.validateAddress)(cleanedAddress);
        setValidAddress(validatedAddress);
        if (validatedAddress) {
            dispatch({
                type: actions_1.CONTEXT_ACTIONS.SET_ADDRESS,
                payload: cleanedAddress,
            });
            setError(false);
        }
        else {
            dispatch({ type: actions_1.CONTEXT_ACTIONS.SET_ADDRESS });
            setError(true);
        }
    }, [dispatch]);
    return (react_1.default.createElement(SlideDrawer_1.default, { show: open, closeFn: handleClose, title: formatMessage({ id: "buy.address-title" }, {
            crypto: selectedCrypto.code,
        }) },
        react_1.default.createElement(styled_1.ContentWrapper, null,
            react_1.default.createElement("div", null,
                react_1.default.createElement(styled_1.Subtitle, null,
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.address-subtitle", values: { crypto: selectedCrypto.code } })),
                !hasPassthrough && (react_1.default.createElement(styled_1.StyledButton, { style: { width: "100%" }, onClick: () => {
                        if (provider && fiatValue && selectedCrypto && selectedFiat) {
                            callback({
                                provider: provider || "",
                                data: {
                                    amount: fiatValue.toString(),
                                    fiat: selectedFiat,
                                    crypto: selectedCrypto.code,
                                    address,
                                },
                            });
                        }
                    } }, "I HAVE A WALLET ADDRESS")),
                hasPassthrough && (react_1.default.createElement(styled_1.InputWrapper, null,
                    react_1.default.createElement(styled_1.StyledInput, { autoFocus: true, value: tempAddress, placeholder: formatMessage({ id: "buy.address-placeholder" }, {
                            crypto: selectedCrypto.code,
                        }), error: error, onChange: handleChange, onKeyUp: (e) => {
                            if (e.key === "Enter" &&
                                provider &&
                                fiatValue &&
                                selectedCrypto &&
                                selectedFiat) {
                                callback({
                                    provider: provider || "",
                                    data: {
                                        amount: fiatValue.toString(),
                                        fiat: selectedFiat,
                                        crypto: selectedCrypto.code,
                                        address,
                                    },
                                });
                            }
                        } }),
                    react_1.default.createElement(styled_1.QRButton, { type: "button", arrow: validAddress, disabled: error, onClick: () => {
                            if (provider &&
                                fiatValue &&
                                selectedCrypto &&
                                selectedFiat &&
                                address &&
                                validAddress) {
                                callback({
                                    provider: provider || "",
                                    data: {
                                        amount: fiatValue.toString(),
                                        fiat: selectedFiat,
                                        crypto: selectedCrypto.code,
                                        address,
                                    },
                                });
                                return;
                            }
                            setQrOpen(true);
                        } }, validAddress || error ? (react_1.default.createElement(ArrowIcon_1.default, { height: 13.2, width: 17.6 })) : (react_1.default.createElement(QRIcon_1.default, { height: 16, width: 16 }))))),
                react_1.default.createElement(QrScanner_1.default, { open: qrOpen, setOpen: setQrOpen }),
                error && (react_1.default.createElement(styled_1.StyledInvalid, null,
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.qrScanner-invalid-address", values: { code: selectedCrypto.code } })))),
            react_1.default.createElement("div", null,
                react_1.default.createElement(NoWallet_1.default, null)))));
};
exports.default = AddressInput;
//# sourceMappingURL=AddressInput.js.map